var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{attrs:{"id":'id-' + _vm.value.id},domProps:{"innerHTML":_vm._s(_vm.value.shortText)}}),_c('b-tooltip',{attrs:{"target":'id-' + _vm.value.id,"placement":"bottom"}},[_vm._v(" "+_vm._s(_vm.value.longText)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }